import { Container } from '@mui/material';
import React from 'react';
import Contract from '../FreezeContracts/Components/Contract/Contract';
import ClearStorageUnmount from './hooks/ClearStorageUnmount';
import UploaderForm from './Components/UploaderForm';

const UploadReceipt = () => {
  // ClearStorageUnmount();
  const receipt_data =
    sessionStorage.getItem('temp_ureceit') &&
    JSON.parse(sessionStorage.getItem('temp_ureceit'));

  return (
    <React.Fragment>
      <Container>
        <br />
        <Contract details={receipt_data} noAction={true} />
        <UploaderForm details={receipt_data} />
      </Container>
    </React.Fragment>
  );
};

export default UploadReceipt;
